import styled from 'styled-components';
import placoleDressyIcon from '../../assets/image/icon/placole_dressy.png'

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px 0 0;
    img {
      height: 75px;
      width: 75px;
    }
`;

const Logo = (props) => {
    return (
      <Wrapper>
          <img src={placoleDressyIcon} alt="PLACOLE & DRESSY" />
      </Wrapper>
    );
  };
  
export default Logo;
  